module.exports = __webpack_public_path__ + "img/layout-background.70adda90.jpg";